import { Component, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { OnboardingStateService } from 'src/app/services/onboarding-state.service';
import { ProgressBarComponent } from 'src/app/shared/components/progress-bar/progress-bar.component';
import { MerchantType } from 'src/app/models/onboarding.model';
import type { ActivityType } from 'src/app/models/cluster.model';
import {
  ACTIVITY_TYPE_CONFIG,
  ACTIVITY_TYPES_BY_MERCHANT,
  ActivityTypeConfig,
} from 'src/app/models/onboarding.labels';
import { OnboardingService } from 'src/app/services/onboarding.service';
import { LogService } from '../../../services/log.service';

interface ActivityOption extends ActivityTypeConfig {
  id: ActivityType;
}

@Component({
  selector: 'app-step-products-type',
  imports: [CommonModule, RouterModule, ProgressBarComponent],
  templateUrl: './step-products-type.component.html',
})
export class StepProductsTypeComponent implements OnInit {
  private log = inject(LogService);
  currentStep = 2;
  totalSteps = 6;

  selectedType: ActivityType | null = null;
  merchantType: MerchantType | null = null;

  activityOptions: ActivityOption[] = [];

  private cdr = inject(ChangeDetectorRef);

  constructor(
    private onboardingStateService: OnboardingStateService,
    private onboardingService: OnboardingService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.onboardingStateService.setCurrentStep(2);

    const data = this.onboardingStateService.getFormData();
    this.merchantType = data?.merchantType || null;

    if (!this.merchantType) {
      this.log.error('merchantType non défini, redirection vers step 1');
      this.router.navigate(['/onboarding/step/1']);
      return;
    }

    // Charger les activityTypes filtrés par merchantType
    const allowedTypes = ACTIVITY_TYPES_BY_MERCHANT[this.merchantType] || [];
    this.activityOptions = allowedTypes.map((id) => ({
      id,
      ...ACTIVITY_TYPE_CONFIG[id],
    }));

    // Restaurer la sélection précédente si valide
    const previousActivity = data?.activityType as ActivityType | undefined;
    const isValid = previousActivity && allowedTypes.includes(previousActivity);

    if (isValid) {
      this.selectedType = previousActivity;
    } else {
      this.selectedType = allowedTypes[0] ?? null;
    }
  }

  selectType(type: ActivityType): void {
    this.selectedType = type;
  }

  getSelectedOption(): ActivityOption | undefined {
    return this.activityOptions.find((opt) => opt.id === this.selectedType);
  }

  getSelectedTypeLabel(): string {
    if (!this.selectedType) return '';
    const option = this.activityOptions.find(
      (opt) => opt.id === this.selectedType,
    );
    return option ? option.label : '';
  }

  continue() {
    if (!this.selectedType) return;

    // Sauvegarder activityType
    this.onboardingStateService.updateFormData({
      activityType: this.selectedType,
    });

    this.onboardingService
      .submitActivityType(this.selectedType as any)
      .subscribe({
        next: (res) => {
          this.log.debug('ActivityType enregistré en DB :', res);
          this.router.navigate(['/onboarding/step/3']);
        },
        error: (err) => {
          this.log.error('Erreur lors de la sauvegarde du activityType :', err);
          this.router.navigate(['/onboarding/step/1']);
        },
      });
  }

  goBack(): void {
    this.router.navigate(['/onboarding/step/1']);
  }
}
